var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-app',{staticClass:"app-container"},[(!_vm.isDeployInProgress && _vm.isAuthenticated)?_c('nav-menu'):_vm._e(),_c('v-main',[(_vm.isDeployInProgress)?_c('DeployInProgress'):_c('router-view')],1),_c('GeneralDialog'),_c('LoadingOverlay')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }